import axios from 'axios';
import { regionFromPathname } from '../utils/regionFromPath';
import { localeFromRegion } from '../i18n';

const LIVE_API_BASE_URL = 'https://apisimilarmovies.vercel.app';
const envApiBase = process.env.REACT_APP_API_BASE_URL;
const baseURL =
  envApiBase && !/localhost|127\.0\.0\.1/i.test(String(envApiBase))
    ? envApiBase
    : LIVE_API_BASE_URL;
const AUTH_STORAGE_KEY = 'simimovies.auth.v1';
const SITE_KEY = (process.env.REACT_APP_SITE_KEY || 'default').trim().toLowerCase();

export const http = axios.create({
  baseURL,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json', 'X-Site': SITE_KEY },
});

function getAuthToken() {
  try {
    const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.token ? String(parsed.token) : '';
  } catch {
    return '';
  }
}

/** Two-letter region segment from path (e.g. /gb/...); used for ad country when not set in the request body. */
export function getApiCountryCode() {
  if (typeof window === 'undefined') return '';
  const r = regionFromPathname(window.location.pathname);
  return r && /^[a-z]{2}$/.test(r) ? r : '';
}

/** BCP-47-ish UI locale from path region; sent as `X-Locale` for ad middleware (`parseAdContext`). */
export function getApiLocaleHeader() {
  if (typeof window === 'undefined') return '';
  const region = regionFromPathname(window.location.pathname);
  return String(localeFromRegion(region) || '').toLowerCase();
}

http.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-Site'] = SITE_KEY;
  const cc = getApiCountryCode();
  if (cc) config.headers['X-Country-Code'] = cc;
  const loc = getApiLocaleHeader();
  if (loc) config.headers['X-Locale'] = loc;
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
